<template>
  <modal
    class="modal"
    name="credits-modal"
    transition="pop-out"
    :adaptive="true"
    :clickToClose="false"
    :heigth="'40vh'"
    :width="'35%'"
    @before-open="beforeOpen"
  >
    <div class="flex flex-column items-center justify-center" style="margin: 0;">
      <div class="flex justify-end w-100">
        <a @click="closeModal" class="pa3 pointer textColor">
          <font-awesome-icon icon="times" size="0.5x" />
        </a>
      </div>

      <div class="text-center">
        <h2 style="text-align: center; margin-top: 0px;">{{ $t("tracks.actions.credits") }}</h2>
        <div class="div-credits">
          <div class="overflow-x-y">
            <ckeditor :readonly="true" v-html="credits"></ckeditor>
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  name: 'credits-modal',
  data () {
    return {
      credits: ''
    }
  },
  methods: {
    closeModal () {
      this.$modal.hide('credits-modal')
    },
    beforeOpen (event) {
      this.credits = event.params.credits !== "''" ? event.params.credits : ''
    }
  }
}
</script>

<style scoped lang="scss">
.overflow-x-y {
  z-index: 10000;
  overflow-x: auto;
  overflow-y: auto;
  max-height: calc(35vh - 6rem);
  max-width: 60%;
  width: calc(60% - 2rem);
  height: calc(35vh - 6rem);
  margin: auto;
  position: relative;
  margin-bottom: 6rem;
}

.div-credits {
  height: calc(40vh - 6rem);
  width: 100%;
  margin-bottom: 6rem;
}

.overflow-x-y::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}

.overflow-x-y::-webkit-scrollbar-thumb {
  background-color: #414040;
  border-radius: 2.5px;
}

.overflow-x-y::-webkit-scrollbar-track {
  background-color: #727272;
}

</style>



// WEBPACK FOOTER //
// src/components/modals/tracks/CreditsModal.vue